<template>
  <div class="vip-integral__svg">
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="543"
      height="439"
      viewBox="0 0 543 439"
    >
      <g transform="translate(-1332 -1728)">
        <path
          d="M730.649,520.67a141.192,141.192,0,0,1-2.1,24.32,139.085,139.085,0,0,1-16.62,45.71,140.072,140.072,0,0,1-242.57-.01,138.932,138.932,0,0,1-16.61-45.7l17.24-3.04a122.514,122.514,0,0,0,241.32,0,123.976,123.976,0,0,0,0-42.56,122.359,122.359,0,0,0-120.66-101.22v-17.5a139.823,139.823,0,0,1,140,140Z"
          transform="translate(1020.251 1382.83)"
          fill="#eb6580"
          stroke="#fff"
          stroke-width="2"
        />
        <path
          d="M713.149,520.67a123.3,123.3,0,0,1-1.84,21.28,122.54,122.54,0,0,1-226.78,39.99l15.16-8.75a105.042,105.042,0,0,0,194.38-70.76,103.97,103.97,0,0,0-12.46-34.28,104.856,104.856,0,0,0-90.96-52.48v-17.5a122.36,122.36,0,0,1,122.5,122.5Z"
          transform="translate(1020.251 1382.33)"
          fill="#ce7cb1"
          stroke="#fff"
          stroke-width="2"
        />
        <path
          d="M695.649,520.67a105.481,105.481,0,0,1-1.58,18.24,104.992,104.992,0,0,1-170.93,62.21l11.25-13.41a87.549,87.549,0,1,0,56.26-154.54v-17.5a104.9,104.9,0,0,1,105,105Z"
          transform="translate(1020.251 1382.83)"
          fill="#8b72b1"
          stroke="#fff"
          stroke-width="2"
        />
        <path
          d="M678.149,520.67a87.522,87.522,0,0,1-163.3,43.77l15.16-8.76a70.063,70.063,0,1,0,60.64-105.01v-17.5a87.436,87.436,0,0,1,87.5,87.5Z"
          transform="translate(1020.251 1382.33)"
          fill="#7ccce7"
          stroke="#fff"
          stroke-width="2"
        />
        <path
          d="M643.149,520.67a52.7,52.7,0,0,1-.79,9.12,52.581,52.581,0,0,1-33.75,40.23l-5.99-16.45a35,35,0,0,0-11.97-67.9v-17.5a52.449,52.449,0,0,1,52.5,52.5Z"
          transform="translate(1020.251 1382.33)"
          fill="#f29969"
          stroke="#fff"
          stroke-width="2"
        />
        <path
          d="M660.649,520.67a70.6,70.6,0,0,1-1.05,12.16,69.4,69.4,0,0,1-8.31,22.85,69.823,69.823,0,0,1-60.64,34.99v-17.5a52.5,52.5,0,1,0,0-105v-17.5a69.911,69.911,0,0,1,70,70Z"
          transform="translate(1020.251 1382.33)"
          fill="#89cbb7"
          stroke="#fff"
          stroke-width="2"
        />
        <text
          transform="translate(1404 1777)"
          fill="#010101"
          font-size="12"
          font-family="PingFangSC-Regular, PingFang SC"
          letter-spacing="0.05em"
        >
          <tspan x="0" y="0">{{ sortArr[0].text }}</tspan>
        </text>
        <text
          transform="translate(1404 1794)"
          fill="#010101"
          font-size="12"
          font-family="PingFangSC-Regular, PingFang SC"
          letter-spacing="0.05em"
        >
          <tspan x="0" y="0">{{ sortArr[1].text }}</tspan>
        </text>
        <text
          transform="translate(1404 1811)"
          fill="#010101"
          font-size="12"
          font-family="PingFangSC-Regular, PingFang SC"
          letter-spacing="0.05em"
        >
          <tspan x="0" y="0">{{ sortArr[2].text }}</tspan>
        </text>
        <text
          transform="translate(1404 1829)"
          fill="#010101"
          font-size="12"
          font-family="PingFangSC-Regular, PingFang SC"
          letter-spacing="0.05em"
        >
          <tspan x="0" y="0">{{ sortArr[3].text }}</tspan>
        </text>
        <text
          transform="translate(1404 1846)"
          fill="#010101"
          font-size="12"
          font-family="PingFangSC-Regular, PingFang SC"
          letter-spacing="0.05em"
        >
          <tspan x="0" y="0">{{ sortArr[4].text }}</tspan>
        </text>
        <text
          transform="translate(1404 1863)"
          fill="#010101"
          font-size="12"
          font-family="PingFangSC-Regular, PingFang SC"
          letter-spacing="0.05em"
        >
          <tspan x="0" y="0">{{ sortArr[5].text }}</tspan>
        </text>
        <text
          transform="translate(1352 2128)"
          fill="#010101"
          font-size="14"
          font-family="PingFangSC-Regular, PingFang SC"
          letter-spacing="0.05em"
        >
          <tspan x="0" y="0">{{ sortArr[0].text }}</tspan>
        </text>
        <text
          transform="translate(1352 2162)"
          fill="#010101"
          font-size="14"
          font-family="PingFangSC-Regular, PingFang SC"
          letter-spacing="0.05em"
        >
          <tspan x="0" y="0">{{ sortArr[1].text }}</tspan>
        </text>
        <text
          transform="translate(1535 2128)"
          fill="#010101"
          font-size="14"
          font-family="PingFangSC-Regular, PingFang SC"
          letter-spacing="0.05em"
        >
          <tspan x="0" y="0">{{ sortArr[2].text }}</tspan>
        </text>
        <text
          transform="translate(1535 2162)"
          fill="#010101"
          font-size="14"
          font-family="PingFangSC-Regular, PingFang SC"
          letter-spacing="0.05em"
        >
          <tspan x="0" y="0">{{ sortArr[3].text }}</tspan>
        </text>
        <text
          transform="translate(1713 2128)"
          fill="#010101"
          font-size="14"
          font-family="PingFangSC-Regular, PingFang SC"
          letter-spacing="0.05em"
        >
          <tspan x="0" y="0">{{ sortArr[4].text }}</tspan>
        </text>
        <text
          transform="translate(1713 2162)"
          fill="#010101"
          font-size="14"
          font-family="PingFangSC-Regular, PingFang SC"
          letter-spacing="0.05em"
        >
          <tspan x="0" y="0">{{ sortArr[5].text }}</tspan>
        </text>
        <text
          transform="translate(1422 2128)"
          fill="#010101"
          font-size="14"
          font-family="Helvetica"
          letter-spacing="0.05em"
        >
          <tspan x="0" y="0">{{ sortArr[0].num }}</tspan>
        </text>
        <text
          transform="translate(1422 2162)"
          fill="#010101"
          font-size="14"
          font-family="Helvetica"
          letter-spacing="0.05em"
        >
          <tspan x="0" y="0">{{ sortArr[1].num }}</tspan>
        </text>
        <text
          transform="translate(1605 2128)"
          fill="#010101"
          font-size="14"
          font-family="Helvetica"
          letter-spacing="0.05em"
        >
          <tspan x="0" y="0">{{ sortArr[2].num }}</tspan>
        </text>
        <text
          transform="translate(1605 2162)"
          fill="#010101"
          font-size="14"
          font-family="Helvetica"
          letter-spacing="0.05em"
        >
          <tspan x="0" y="0">{{ sortArr[3].num }}</tspan>
        </text>
        <text
          transform="translate(1783 2128)"
          fill="#010101"
          font-size="14"
          font-family="Helvetica"
          letter-spacing="0.05em"
        >
          <tspan x="0" y="0">{{ sortArr[4].num }}</tspan>
        </text>
        <text
          transform="translate(1783 2162)"
          fill="#010101"
          font-size="14"
          font-family="Helvetica"
          letter-spacing="0.05em"
        >
          <tspan x="0" y="0">{{ sortArr[5].num }}</tspan>
        </text>
        <circle
          cx="4"
          cy="4"
          r="4"
          transform="translate(1332 2119)"
          fill="#eb6580"
        />
        <circle
          cx="4"
          cy="4"
          r="4"
          transform="translate(1515 2119)"
          fill="#8b72b1"
        />
        <circle
          cx="4"
          cy="4"
          r="4"
          transform="translate(1693 2119)"
          fill="#89cbb7"
        />
        <circle
          cx="4"
          cy="4"
          r="4"
          transform="translate(1332 2153)"
          fill="#ce7cb1"
        />
        <circle
          cx="4"
          cy="4"
          r="4"
          transform="translate(1515 2153)"
          fill="#7ccce7"
        />
        <circle
          cx="4"
          cy="4"
          r="4"
          transform="translate(1693 2153)"
          fill="#f29969"
        />
        <path
          d="M.027-1H139.709l-.027,15H0Z"
          transform="translate(1473 1765.5)"
          fill="#eb6580"
        />
        <path
          d="M.016-1h139.7V14.5H.016Z"
          transform="translate(1472.997 1782.5)"
          fill="#ce7cb1"
        />
        <path
          d="M.016-1h139.7V14.5H.016Z"
          transform="translate(1472.997 1817.5)"
          fill="#7ccce7"
        />
        <path
          d="M.016-1h139.7V14.5H.016Z"
          transform="translate(1472.997 1852.5)"
          fill="#f29969"
        />
        <path
          d="M.026-.5H139.716l-.01,15H.016Z"
          transform="translate(1472.997 1800)"
          fill="#8b72b1"
        />
        <path
          d="M.069-.969H139.737L139.684,14.5H.016Z"
          transform="translate(1472.997 1835)"
          fill="#89cbb7"
        />
        <text
          transform="translate(1487 1777)"
          fill="#fff"
          font-size="14"
          font-family="Arial-BoldMT, Arial"
          font-weight="700"
        >
          <tspan x="0" y="0">
            {{ ((+sortArr[0].num / integralTotal) * 100).toFixed(2) }}%
          </tspan>
        </text>
        <text
          transform="translate(1487 1794)"
          fill="#fff"
          font-size="14"
          font-family="Arial-BoldMT, Arial"
          font-weight="700"
        >
          <tspan x="0" y="0">
            {{ ((+sortArr[1].num / integralTotal) * 100).toFixed(2) }}%
          </tspan>
        </text>
        <text
          transform="translate(1487 1811)"
          fill="#fff"
          font-size="14"
          font-family="Arial-BoldMT, Arial"
          font-weight="700"
        >
          <tspan x="0" y="0">
            {{ ((+sortArr[2].num / integralTotal) * 100).toFixed(2) }}%
          </tspan>
        </text>
        <text
          transform="translate(1487 1829)"
          fill="#fff"
          font-size="14"
          font-family="Arial-BoldMT, Arial"
          font-weight="700"
        >
          <tspan x="0" y="0">
            {{ ((+sortArr[3].num / integralTotal) * 100).toFixed(2) }}%
          </tspan>
        </text>
        <text
          transform="translate(1487 1846)"
          fill="#fff"
          font-size="14"
          font-family="Arial-BoldMT, Arial"
          font-weight="700"
        >
          <tspan x="0" y="0">
            {{ ((+sortArr[4].num / integralTotal) * 100).toFixed(2) }}%
          </tspan>
        </text>
        <text
          transform="translate(1487 1864)"
          fill="#fff"
          font-size="14"
          font-family="Arial-BoldMT, Arial"
          font-weight="700"
        >
          <tspan x="0" y="0">
            {{ ((+sortArr[5].num / integralTotal) * 100).toFixed(2) }}%
          </tspan>
        </text>
        <text
          transform="translate(1787 1743)"
          fill="#010101"
          font-size="14"
          font-family="PingFangSC-Regular, PingFang SC"
          letter-spacing="0.05em"
        >
          <tspan x="0" y="0">（单位：人）</tspan>
        </text>
      </g>
    </svg>
  </div>
</template>
<script>
export default {
  name: 'VipIntegralSvg',
  props: {
    vipIntegralData: {
      type: Array
    },
    integralTotal: {
      type: [Number, String]
    }
  },
  data() {
    return {}
  },
  computed: {
    sortArr() {
      return this.vipIntegralData.sort(this.utils._compare('num', 'des'))
    }
  }
}
</script>
